export default values => ({
  phone: values?.phone ?? '',
  email: values?.email ?? '',
  officePhone: values?.officePhone ?? '',
  homePhone: values?.homePhone ?? ''
});
